import { render } from "./RecentOrdersList.vue?vue&type=template&id=4cd7e3e1&scoped=true&ts=true"
import script from "./RecentOrdersList.vue?vue&type=script&lang=ts"
export * from "./RecentOrdersList.vue?vue&type=script&lang=ts"

import "./RecentOrdersList.vue?vue&type=style&index=0&id=4cd7e3e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd7e3e1"]])

export default __exports__